import { useEffect } from 'react';
import { useAccount } from 'wagmi';
import { datadogRum } from '@datadog/browser-rum';
import { identify } from '@cbhq/client-analytics';
import { getDeviceId } from '@/app/utils/analytics/getDeviceId';

// Hook to handle wallet connection changes
export function useAnalyticsWalletTracking() {
  const { address } = useAccount();
  const deviceId = getDeviceId();
  useEffect(() => {
    if (address) {
      identify({
        deviceId,
        userId: address ?? deviceId, // Use wallet address as userId if available, fallback to deviceId
      });

      // Set Datadog RUM user context so sessions and errors can be
      // correlated to a specific wallet address
      datadogRum.setUser({ id: address });
    } else {
      // Clear user context on disconnect
      datadogRum.clearUser();
    }
  }, [address, deviceId]);
}
